import http from "@/http-common";

const BASE = "statistics/employee-schedule";

class EmployeeScheduleKpiService {
  getKpi(employeeId, startDate, endDate) {
    return http.get(`${BASE}/kpi`, {
      params: { employeeId, startDate, endDate }
    });
  }
}

export default new EmployeeScheduleKpiService();
